import { FC, Fragment, useState } from 'react'
import { Link } from 'react-router-dom';
import './Dropdown.css';
import { Divider } from '@mui/material';
import { MenuItemsFacturation } from '../../../constants/MenuItems';
import { DropdownMenuProps } from './Dropdown';
import MenuItem from '../../../types/MenuItem';
import { profilToAccessToAllFonctionnality } from '../../../constants/Constants';

const DropdownFacture: FC<DropdownMenuProps> = ({ user }) => {
    const [click, setClick] = useState(false);

    const handleClick = () => setClick(!click);

    const normalItemMenu = (item: MenuItem, index: number) => {
        return (
            <Fragment>
                <li key={index}>
                    <Link
                        className={item.cName}
                        to={item.path}
                        onClick={() => setClick(false)}
                    >
                        {item.title}
                    </Link>
                </li>
                <Divider sx={{ color: '#201f1e' }} />
            </Fragment>
        );
    }

    /* const disabledItemMenu = (item: MenuItem, index: number) => {
        return (
            <Fragment>
                <li key={index}>
                    <div className={item.cName} style={{ color: "#CFCFCF" }}>
                        {item.title}
                    </div>
                </li>
                <Divider sx={{ color: '#CFCFCF' }} />
            </Fragment>
        );
    } */

    const deFaultMenuItem = (item: MenuItem, index: number) => {
        if (user?.profils?.libelle && profilToAccessToAllFonctionnality?.includes(user?.profils?.libelle)) {
            return normalItemMenu(item, index);
        } else {
            if (user?.updated_password) {
                if (user?.features?.includes(item.code)) {
                    return normalItemMenu(item, index);
                }
            }

            /* if (user?.updated_password) {
                return user?.features?.includes(item.code) ? normalItemMenu(item, index) : disabledItemMenu(item, index);
            } else {
                return disabledItemMenu(item, index);
            } */
        }
    };

    return (
        <>
            <ul
                onClick={handleClick}
                className={click ? 'dropdown-menu-fact clicked' : 'dropdown-menu-fact'}
            >
                {MenuItemsFacturation.map((item, index) => {
                    return deFaultMenuItem(item, index);
                })}
            </ul>
        </>
    );
};

export default DropdownFacture;